<template>
  <v-layout row class="pa-2">
    <v-flex xs6 d-flex style="flex-direction: column; height: 50vh">
      <v-subheader inset style="flex: 0 0 auto !important">Colectii APL-uri</v-subheader>
      <v-divider></v-divider>
      <v-list three-line dense style="overflow: auto; flex: 1 0 auto !important">
        <v-list-tile v-for="collection in collections" :key="collection._id" @click="_cbSelectActiveCollection(collection._id)" :color="activeCollection && activeCollection._id === collection._id ? 'accent' : ''">
          <v-list-tile-action>
            <v-tooltip top>
              <div slot="activator">
                <v-icon :color="collection.public ? 'primary' : 'error'">
                  {{collection.public ? 'mdi-emoticon-kiss' : 'mdi-emoticon-devil'}}
                </v-icon>
              </div>
              <div>
                {{collection.public ? 'colectie publica' : 'colectie privata'}}
              </div>
            </v-tooltip>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{collection.denumire}} ({{collection.apluri.length}} APL-uri)
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <v-icon small>
                mdi-calendar-plus
              </v-icon>
              {{collection.createdAt | shortDate}}
              <br>
              <v-icon small>
                mdi-calendar-edit
              </v-icon>
              {{collection.updatedAt | shortDate}}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action style="flex-direction: row; align-items: center">
            <v-icon :style="{visibility: activeCollection && activeCollection._id === collection._id ? 'visible' : 'hidden'}">mdi-menu-right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-pagination
        style="flex: 0 0 auto !important; align-self: center"
        circle
        v-model="collectionsPage"
        :length="allCollectionsLength"
        :total-visible="5"
        class="ob-log">
      </v-pagination>
    </v-flex>
    <v-divider inset vertical class="ma-0"></v-divider>
    <v-flex xs6 d-flex style="flex-direction: column; height: 50vh">
      <v-subheader style="flex: 0 0 auto !important">
        {{activeCollection ? activeCollection.apluri.length : ''}} APL-uri in colectia {{activeCollection ? activeCollection.denumire : '...'}}
      </v-subheader>
      <v-divider></v-divider>
      <v-list v-if="activeCollection" two-line dense style="overflow: auto; flex: 1 0 auto !important">
        <v-list-tile v-for="apl in apluri" :key="`${apl.cif_op}-${apl.cif_os}`">
          <v-list-tile-content>
            <v-list-tile-title>{{apl.denumire}} - {{apl.judet}}</v-list-tile-title>
            <v-list-tile-sub-title>{{apl.cif_op}} - {{apl.cif_os}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-pagination
        v-if="activeCollection"
        style="flex: 0 0 auto !important; align-self: center"
        circle
        v-model="apluriPage"
        :length="allAPLuriLength"
        :total-visible="5"
        class="ob-log">
      </v-pagination>
    </v-flex>
  </v-layout>
</template>

<script>
import faker from 'faker'

export default {
  name: 'colectii-apl',
  props: {

  },
  data: () => ({
    activeCollection: null,
    collectionsPage: 1,
    apluriPage: 1,
    perPage: 5
  }),
  computed: {
    allCollections () {
      return new Array(93).fill(null).map(list => ({
        _id: faker.random.uuid(),
        denumire: faker.company.companyName(),
        public: faker.random.boolean(),
        full: faker.random.boolean(),
        apluri: new Array(Math.ceil(Math.random() * 50)).fill(null).map(apl => ({
          cif_op: faker.random.number(),
          cif_os: faker.random.number(),
          denumire: faker.address.city(),
          judet: faker.address.county()
        })),
        createdAt: faker.date.past(),
        updatedAt: faker.date.recent()
      }))
    },
    collections () {
      return this.allCollections.slice((this.collectionsPage - 1) * this.perPage, this.collectionsPage * this.perPage)
    },
    apluri () {
      if (this.activeCollection) {
        return this.activeCollection.apluri.slice((this.apluriPage - 1) * this.perPage, this.apluriPage * this.perPage)
      }

      return []
    },
    allCollectionsLength () {
      return Math.ceil(this.allCollections.length / this.perPage)
    },
    allAPLuriLength () {
      if (this.activeCollection) {
        return Math.ceil(this.activeCollection.apluri.length / this.perPage)
      }

      return 0
    }
  },
  methods: {
    _cbSelectActiveCollection (collectionID) {
      this.activeCollection = this.collections.find(collection => collection._id === collectionID)
      this.apluriPage = 1
    }
  }
}
</script>
